import alt from 'components/Dispatcher';
import MediaActions from 'actions/MediaActions';
import { browserHistory } from 'react-router';
import API from 'sources/API';

class CommentActions {
    updateComments(comments) {
        return comments;
    }
    fetchComments(mid) {
        return mid;
    }
    postComment(comment) {
        return comment;
    }
    addComment(comment) {
        return comment;
    }
    receivedComments(res) {
        if(res.status === 0) {
            this.updateComments(res.result);
        } else {
            this.fetchCommentsFailed(res);
        }
        return res;
    }
    fetchCommentsFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }
        return err;
    }
    postCommentSuccess(res) {
        if(res.status === 0) {
            MediaActions.fetchMedia(res.result.media_id);
        } else {
            this.postCommentFailed(res);
        }
        return res;
    }
    postCommentFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }
        return err;
    }
}

export default alt.createActions(CommentActions);



// WEBPACK FOOTER //
// ./src/actions/CommentActions.js